import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import useStore from './store/useStore';
import { gateApi } from './services/api';
import { PageDataProvider } from './pm/contexts/PageDataContext';
import Layout from './components/Layout';
import GateAuth from './pages/GateAuth';
import KnowledgeBase from './pages/KnowledgeBase';
import Workbench from './pages/Workbench';

function App() {
  const {
    isGateAuthenticated,
    setGateAuthenticated
  } = useStore();

  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Check gate auth on mount
  useEffect(() => {
    const checkGateAuth = async () => {
      try {
        const response = await gateApi.check();
        setGateAuthenticated(response.data.authenticated);
      } catch (error) {
        setGateAuthenticated(false);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkGateAuth();
  }, [setGateAuthenticated]);

  // Show loading while checking auth
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen bg-galaxy-950 flex items-center justify-center">
        <div className="text-galaxy-400">Loading...</div>
      </div>
    );
  }

  // Show gate auth if not authenticated
  if (!isGateAuthenticated) {
    return <GateAuth />;
  }

  return (
    <PageDataProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/knowledge-base" replace />} />
            <Route path="knowledge-base" element={<KnowledgeBase />} />
            <Route path="workbench" element={<Workbench />} />
          </Route>
        </Routes>
      </Router>
    </PageDataProvider>
  );
}

export default App;
